const DATA_RETENTION_DAYS = 12;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function daysUntilDataDeletion(
  cancelledAt: string | null,
  now: Date = new Date()
): number | null {
  if (!cancelledAt) return null;
  const cancelled = new Date(cancelledAt);
  if (Number.isNaN(cancelled.getTime())) return null;

  const elapsedDays = Math.floor((now.getTime() - cancelled.getTime()) / MS_PER_DAY);
  return Math.max(0, DATA_RETENTION_DAYS - elapsedDays);
}
